<template>
  <div v-if="load" class="loading">
    <v-progress-circular size="130" width="10" color="primary" indeterminate>
      <v-avatar>
        <span>HQ</span>
      </v-avatar>
    </v-progress-circular>
  </div>
</template>

<script>

  export default {
    name: "Preloader",
    props: {
      load: { type: Boolean, default: true },
      logo: { type: String }
    },
  }
</script>

<style lang="scss" scoped>
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $white;
    z-index: 999;

    .v-progress-circular {
      max-width: 100%;
    }

    & .v-avatar {
      min-width: 110px !important;
      height: 110px !important;
    }
    & span {
      font-size: 55px;
    }
  }

  .v-progress-circular--indeterminate >>> svg {
    opacity: 0.4;
  }
</style>
